import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', () => {
    // #region USER

    function getUser() {
        return localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null;
    }

    function setLocale(appParam = null, locale = null, refresh = false) {
        let choosedLocale = 'fr';

        if (appParam != null && isLogged() && locale == null)
            choosedLocale = getUser().locale != null ? getUser().locale : 'fr';
        else if (locale != null)
            choosedLocale = locale;

        appParam.$i18n.locale = choosedLocale;

        if (refresh)
            logOff();
    }

    function isLogged() {
        return getUser() != null && getUser().id > 0;
    }

    function isAdmin() {
        return getUser() != null && getUser().accessLevel == 255;
    }

    function logOff() {
        localStorage.setItem('user', null);
        localStorage.setItem('lastLoginDate', null);
        window.location.href = window.location.origin;
    }

    // #endregion

    return {
        // user
        getUser,
        setLocale,
        isLogged,
        isAdmin,
        logOff,
    };
});
